import Styles from "./styled";
import ScreenFrame from "../../templates/ScreenFrame";
import DoubleNav from "../../templates/DoubleNav";
import ImagesData from "../../../data/assets/images/images";
import useMaze from "./hook";
import ScreenBackground from "../../templates/ScreenBackground";

const {  progressBarFlash, diamond } = ImagesData;

const {
    StampsWrapper,
    Stamp,
    PointsAmount,
    PointsGain,
    StampContainer,
    DiamondIcon,
} = Styles;

const pointsLeftPosition = (idx: number, stampsCount: number) => -8 + (idx * 28.5);

const Maze = () => {
    const {
        stamps,
        pointsdelta,
        animTrigger,
        pointFlashAnimActive,
        noOfKiosksCompleted,
        allPointsCollected,
        totalKiosksForAttraction,
    } = useMaze();

    return (
        <ScreenFrame>
            <ScreenBackground />
            <DoubleNav />
            <StampsWrapper>
                {stamps.map((x, idx) => (
                    <StampContainer
                        key={idx}
                        animActive={allPointsCollected}
                        addCoinAnimActive={false}
                        leftDest={"0px"}
                        topDest={"0px"}
                        left={pointsLeftPosition(idx, stamps.length)}
                    >
                        <Stamp src={x} />
                        {noOfKiosksCompleted == idx + 1 &&
                            totalKiosksForAttraction != idx + 1 && (
                                <>
                                    <PointsAmount
                                        left={"0"}
                                        top={"0"}
                                        isAnimationActive={true}
                                    >
                                        +{pointsdelta}
                                    </PointsAmount>
                                    <DiamondIcon
                                        left={"0"}
                                        top={"0"}
                                        isAnimationActive={true}
                                        src={diamond}
                                    />
                                    <PointsGain
                                        animActive={pointFlashAnimActive}
                                        src={
                                            progressBarFlash +
                                            "?x=" +
                                            animTrigger
                                        }
                                    />
                                </>
                            )}
                    </StampContainer>
                ))}
               
            </StampsWrapper>
        </ScreenFrame>
    );
};

export default Maze;
